import * as React from 'react';
import * as L from 'leaflet';
import styled from 'styled-components';

import 'leaflet/dist/leaflet.css';

const Caixa = styled.div`
  border: 1px solid hsl(214 32% 91%);
  border-radius: 10px;
  height: 220px;
  margin-top: 8px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const Aviso = styled.div`
  align-items: center;
  background: #f2f5f9;
  color: #5b6b7c;
  display: flex;
  font-size: 13px;
  height: 100%;
  justify-content: center;
  padding: 0 16px;
  text-align: center;
`;

const Tela = styled.div`
  height: 100%;
  width: 100%;
`;

const ZOOM = 15;

interface Props {
  latitude?: number | null;
  longitude?: number | null;
  /** Mensagem quando nao ha coordenada: o cadastro segue mesmo assim. */
  mensagemVazia?: string;
}

export const RegisterMap: React.FC<Props> = ({
  latitude,
  longitude,
  mensagemVazia = 'Digite o CEP para ver o endereço no mapa.',
}) => {
  const container = React.useRef<HTMLDivElement | null>(null);
  const mapa = React.useRef<L.Map | null>(null);
  const marcador = React.useRef<L.CircleMarker | null>(null);

  const temCoordenada = typeof latitude === 'number' && typeof longitude === 'number';

  React.useEffect(() => {
    if (!temCoordenada || !container.current) return;

    // O mapa e criado uma vez e depois so recentralizado. Recriar a cada
    // mudanca de CEP vazaria a instancia anterior e recarregaria os tiles.
    if (!mapa.current) {
      mapa.current = L.map(container.current, {
        zoomControl: true,
        scrollWheelZoom: false,
        attributionControl: true,
      }).setView([latitude as number, longitude as number], ZOOM);

      // A atribuicao e exigida pela politica de uso dos tiles do OSM.
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; colaboradores do OpenStreetMap',
      }).addTo(mapa.current);
    } else {
      mapa.current.setView([latitude as number, longitude as number], ZOOM);
    }

    // Circulo, e nao pino: o CEP aponta a rua, nao o numero. Um pino sugere
    // uma precisao que o dado nao tem.
    if (marcador.current) {
      marcador.current.setLatLng([latitude as number, longitude as number]);
    } else {
      marcador.current = L.circleMarker([latitude as number, longitude as number], {
        radius: 10,
        color: '#006bf3',
        fillColor: '#006bf3',
        fillOpacity: 0.25,
        weight: 2,
      }).addTo(mapa.current);
    }
  }, [latitude, longitude, temCoordenada]);

  React.useEffect(
    () => () => {
      mapa.current?.remove();
      mapa.current = null;
      marcador.current = null;
    },
    [],
  );

  return (
    <Caixa>
      {temCoordenada ? (
        <Tela ref={container} aria-label="Mapa do endereço" />
      ) : (
        <Aviso>{mensagemVazia}</Aviso>
      )}
    </Caixa>
  );
};
